import { ComponentElem } from "@components/interfaces";
import PopupBase from "@components/popups/PopupBase";

export default class LineQRCode extends PopupBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
  }
}